import React, {Component} from 'react'
import Hero from "./Hero";
import Subjects from "./Subjects";
import Lessons from "./Lessons";
import ContactIndex from "../Contact/ContactIndex";
import Tutors from "./Tutors";
import Testimonials from "./Testimonials";

class LandingPageIndex extends Component {
    render() {
        return (
            <div id="landingPageIndex">
                <section id="heroSection">
                    <Hero/>
                </section>
                <section id="subjects">
                    <Subjects/>
                </section>
                <section id="lessons">
                    <Lessons/>
                </section>
                <section id="tutors">
                    <Tutors/>
                </section>
                <section id="testimonials">
                    <Testimonials/>
                </section>
                <secion id="contact">
                    <ContactIndex/>
                </secion>
            </div>
        )
    }
}

export default LandingPageIndex